import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IAppStore } from "../../iappstore";
import { IAzureAuthentication } from "../../interfaces/iazureauthentication";
import { Store } from "@ngrx/store";
import { SetTokenAction } from "../../actions/azureauthentication.action";
import { ClearSelectedBusinessFunctionAction } from "../../actions/applicationuser.action";

@Component({
    selector: "signedout",
    templateUrl: "./signedout.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class SignedOutComponent {
    constructor(private store: Store<IAppStore>) {
        this.store.dispatch(new SetTokenAction({ token: null } as IAzureAuthentication));
        this.store.dispatch(new ClearSelectedBusinessFunctionAction());
    }
}

